import React from 'react';
import { usePayment } from '../../../Data/Payments';
import { PageLoading } from '../../../Components/Loading';
import Grid from '../../../Components/Formatting/Grid';
import Money from '../../../Components/Formatting/Money';
import Icon from '../../../Components/Icons/Icon';
import NoValue from '../../../Components/EmptyStates/NoValue';
import Address from '../../../Components/Formatting/Address';
import DateTime from '../../../Components/Formatting/DateTime';
import { useHelp } from '../../../Components/Help';
import Modal from '../../../Components/Modal';
import Button from '../../../Components/Button/Button';
import ButtonRow from '../../../Components/Button/ButtonRow';

const Payment = ({isOpen, setIsOpen, paymentId, matchCustomer, unmatchCustomer}) => {
    const {payment} = usePayment(paymentId, true);

    return <Modal title="Payment" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {payment ? <Inner {...{payment, matchCustomer, unmatchCustomer}} /> : <PageLoading />}
    </Modal>
}

const Inner = ({payment, matchCustomer, unmatchCustomer}) => {
    const {docTrigger} = useHelp();

    return <>
        <Grid items={[
            [
                <strong>ID</strong>,
                '#'+payment.shortId
            ],
            [
                <strong>Method</strong>,
                payment.paymentMethod
            ],
            [
                <strong>Amount</strong>,
                <Money pence={payment.pence} />
            ],
            [
                <strong>Fees</strong>,
                payment.stripeFees ? <Money pence={payment.soapyFees + payment.stripeFees} /> : <Processing />,
            ],
            [
                <strong>Net</strong>,
                payment.net ? <Money pence={payment.net} /> : <Processing />,
            ],
            [
                <strong>Status</strong>,
                <>
                    {payment.status}
                    {docTrigger('paymentStatuses')}
                </>,
            ],
            [
                <strong>Name</strong>,
                payment.name,
            ],
            [
                <strong>Email</strong>,
                payment.email ?? <NoValue />,
            ],
            [
                <strong>Address</strong>,
                payment.address ? <Address address={payment.address} /> : <NoValue />,
            ],
            [
                <strong>Date</strong>,
                <DateTime date={payment.completedAt ?? payment.startedAt} />,
            ],
        ]} />

        <ButtonRow>
            <Button theme="primary"
                icon="UserMagnifyingGlass"
                label="Match to customer"
                hide={payment.customerId}
                onClick={() => matchCustomer(payment)}
            />
            <Button theme="primary"
                icon="UserSlash"
                label="Remove from customer"
                hide={!payment.customerId}
                onClick={() => unmatchCustomer(payment)}
            />
        </ButtonRow>
    </>
}

const Processing = () => {
    return <span className="text-muted fill-muted">
        <Icon icon="Clock" size="0.5x" className="mr-2" />
        Processing
    </span>
}

export default Payment;
